<template>
  <div class="d-flex flex-column tw-mb-12">
    <h1 class="section-divider-underline">
      {{ $t("candidateProfile.detail") }}
    </h1>
    <div class="row">
      <div class="col-md-6 tw-space-y-3">
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.registerDate") }}</label
          >
          <div class="col-md-7">
            <a-date-picker
              v-model="model.register_date"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onChangeRegisterDate"
            />
            <div class="text-danger" v-if="errors.has('register_date')">
              {{ errors.first("register_date") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
          >
            {{ $t("candidateProfile.maritalStatus") }}
          </label>
          <div class="col-md-7">
            <select
              v-model="model.marital_status"
              class="form-select"
              :class="{ 'is-invalid': errors.has('marital_status') }"
            >
              <option :value="null" selected style="display: none">
                {{ $t("select") }}
              </option>
              <option :value="0">Single</option>
              <option :value="1">Mariage</option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('marital_status')">
              {{ errors.first("marital_status") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.phone") }}</label
          >
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.phone"
              class="form-control"
              :class="{ 'is-invalid': errors.has('phone') }"
            />
            <div class="invalid-feedback" v-if="errors.has('phone')">
              {{ errors.first("phone") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.emergencyContact") }}</label
          >
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.emergency_contact"
              class="form-control"
              :class="{ 'is-invalid': errors.has('emergency_contact') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('emergency_contact')"
            >
              {{ errors.first("emergency_contact") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.occupationEn") }}</label
          >
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.occupation_en"
              class="form-control"
              :class="{ 'is-invalid': errors.has('occupation_en') }"
            />
            <div class="invalid-feedback" v-if="errors.has('occupation_en')">
              {{ errors.first("occupation_en") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("candidateProfile.culturalLevel")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.cultural_level"
              class="form-control"
              :class="{ 'is-invalid': errors.has('cultural_level') }"
            />
            <div class="invalid-feedback" v-if="errors.has('cultural_level')">
              {{ errors.first("cultural_level") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.pob") }}</label
          >
          <div class="col-md-7">
            <textarea
              rows="2"
              v-model="model.pob"
              class="form-control"
              :class="{ 'is-invalid': errors.has('pob') }"
            ></textarea>
            <div class="invalid-feedback" v-if="errors.has('pob')">
              {{ errors.first("pob") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("candidateProfile.foreignLanguages")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.foreign_languages"
              class="form-control"
              :class="{ 'is-invalid': errors.has('foreign_languages') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('foreign_languages')"
            >
              {{ errors.first("foreign_languages") }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 tw-space-y-3">
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("candidateProfile.email")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.email"
              class="form-control"
              :class="{ 'is-invalid': errors.has('email') }"
            />
            <div class="invalid-feedback" v-if="errors.has('email')">
              {{ errors.first("email") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">
            {{ $t("candidateProfile.telegram") }}
          </label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.telegram"
              class="form-control"
              :class="{ 'is-invalid': errors.has('telegram') }"
            />
            <div class="invalid-feedback" v-if="errors.has('telegram')">
              {{ errors.first("telegram") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">
            {{ $t("candidateProfile.facebook") }}
          </label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.facebook"
              class="form-control"
              :class="{ 'is-invalid': errors.has('facebook') }"
            />
            <div class="invalid-feedback" v-if="errors.has('facebook')">
              {{ errors.first("facebook") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("candidateProfile.line")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.line"
              class="form-control"
              :class="{ 'is-invalid': errors.has('line') }"
            />
            <div class="invalid-feedback" v-if="errors.has('line')">
              {{ errors.first("line") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.occupationKh") }}</label
          >
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.occupation_kh"
              class="form-control"
              :class="{ 'is-invalid': errors.has('occupation_kh') }"
            />
            <div class="invalid-feedback" v-if="errors.has('occupation_kh')">
              {{ errors.first("occupation_kh") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("candidateProfile.examSession")
          }}</label>
          <div class="col-md-7">
            <a-date-picker
              v-model="model.exam_session"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onChangeExamSession"
            />
            <div class="text-danger" v-if="errors.has('exam_session')">
              {{ errors.first("exam_session") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("candidateProfile.pobKh") }}</label
          >
          <div class="col-md-7">
            <textarea
              rows="2"
              v-model="model.pob_kh"
              class="form-control"
              :class="{ 'is-invalid': errors.has('pob_kh') }"
            ></textarea>
            <div class="invalid-feedback" v-if="errors.has('pob_kh')">
              {{ errors.first("pob_kh") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-col-label control-label col-md-5"></label>
          <div class="col-md-7 tw-space-x-2">
            <input type="checkbox" v-model="model.is_external" />
            <label class="form-col-label control-label col-md-5">{{
              $t("candidateProfile.isExternal")
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "detail",
  props: ["value", "validation"],
  data() {
    return {
      status: [],
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/candidateProfile", ["formViewDatas", "edit_data"]),
    statusReasons() {
      if (this.model.status_id) {
        return this.formViewDatas.statusReason.filter(
          (s) => s.status_reason_id == this.model.status_id
        );
      }
      return this.statusReason;
    },
  },
  methods: {
    onChangeRegisterDate(dateString) {
      this.model.register_date = dateString;
      this.model.probation_end_date = moment(
        this.model.register_date,
        "DD-MM-YYYY"
      )
        .add(3, "M")
        .format("DD-MM-YYYY");
    },
    onChangeExamSession(dateString) {
      this.model.exam_session = dateString;
      this.model.probation_end_date = moment(
        this.model.exam_session,
        "DD-MM-YYYY"
      )
        .add(3, "M")
        .format("DD-MM-YYYY");
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
